









import { defineComponent } from '@vue/composition-api';
import { useSports } from '../composition/useSports';
import { RouteName } from '@app/router/constants/RouteName';
import { AvailableCompetitionTabs } from '@sportOfferFederation/competitions/store/ui/types';
import { Location } from 'vue-router';

export default defineComponent({
    name: 'UseSportRoute',
    setup() {
        const { resolveSportRoute } = useSports();

        /**
         *
         * @param tournamentIds in CSV format
         * @example
         * getTournamentRoute('id0,id1,id2')
         * // { name: RouteName.Sport.TournamentRedirect, params: { id: 'id0,id1,id2' }, query: { ct: 'social' } }
         */
        function getTournamentRoute(tournamentIds: string): Location {
            return {
                name: RouteName.Sport.TournamentRedirect,
                params: {
                    id: tournamentIds,
                },
                query: {
                    ct: AvailableCompetitionTabs.Social,
                },
            };
        }

        function resolveSportSocialRoute(sportId: number) {
            const { route: { params } } = resolveSportRoute(sportId);

            const { sportSlug } = params;

            return {
                name: RouteName.Sport.Social,
                params: {
                    sportSlug,
                },
            };
        }

        return {
            resolveSportSocialRoute,
            getTournamentRoute,
        };
    },
});
